import { useAuth } from '../auth/AuthContext';
import { useT } from '../lib/i18n';
import { Icon } from './primitives';

/**
 * A persistent banner shown while an IT admin is impersonating another user, so
 * the acting state is never ambiguous. Offers a one-click return to the admin's
 * own session.
 */
export function ImpersonationBanner() {
  const { user, impersonator, stopImpersonation } = useAuth();
  const t = useT();
  if (!impersonator) return null;

  return (
    <div className="imp-banner" role="status">
      <Icon name="headset" size={17} />
      <span className="imp-banner-text">
        <span>
          {t('impersonation.bannerPrefix')} <strong>{user?.displayName}</strong>
        </span>
        <span className="imp-banner-sub">
          {t('impersonation.bannerActor', { name: impersonator.displayName })}
        </span>
      </span>
      <button type="button" className="imp-banner-stop" onClick={() => void stopImpersonation()}>
        {t('impersonation.stop')}
      </button>
    </div>
  );
}
